var _defs, _polygon, _polygon2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2264b0;}.cls-2{fill:#0c2c65;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.7245 .4825 18.4674 .4825 37.7245 16.3001 37.7245 .4825"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: ".2196 39.5174 21.0412 39.5174 .2196 23.213 .2196 39.5174"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.6878,22.5687c-.855-1.5366-2.2756-3.0937-4.2546-4.6807L13.4929.7304c-1.4249.0183-2.5672.0959-3.4403.2253-.8901.1452-1.7946.402-2.6992.7458-2.3279.939-4.1329,2.3421-5.4241,4.2047-1.2862,1.8463-1.9293,4.0325-1.9293,6.5353,0,.9123.1332,1.8802.3986,2.9234.2445,1.0344.5934,1.9951,1.0325,2.8695.5646,1.0562,1.5019,2.2867,2.826,3.6899,1.3356,1.4639,3.1449,3.1421,5.4244,5.0192,2.3225,1.984,4.7342,3.8924,7.2253,5.7211,1.5411,1.1252,2.8612,2.0821,3.9841,2.8716,1.1252.7921,3.0219,2.12,5.6908,3.9813,1.0091-.0288,1.8704-.0784,2.5736-.1439.6299-.0654,1.2589-.1673,1.8834-.3227.4523-.0995.9856-.2773,1.6117-.5478,2.2756-.9202,4.0651-2.337,5.3681-4.2505,1.3226-1.9084,1.9815-4.0572,1.9815-6.4388,0-1.9316-.434-3.6805-1.3122-5.2451"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.bc6f9dd89f69b84b35e507c16c364e37.svg";
export { ForwardRef as ReactComponent };